import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { TextInput } from '../../form-generator/components';
import CommissionValuesSidebar from '../inventory/CommissionValuesSidebar';

const MockCommissionManualFields = forwardRef(({ value, onChange, onValuesChange, appChoices }, ref) => {
  const [showCommissionSidebar, setShowCommissionSidebar] = useState(false);
  const latestValueRef = useRef(value);

  latestValueRef.current = value;

  const notifyValuesChange = nextValue => {
    latestValueRef.current = nextValue;
    if (onChange) {
      onChange(nextValue);
    }
    if (onValuesChange) {
      onValuesChange(nextValue);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      save: async () => {
        if (!latestValueRef.current) return true;
        notifyValuesChange(latestValueRef.current);
        return true;
      }
    }),
    []
  );

  if (!value) return null;

  const updateInvoice = invoiceValue => {
    notifyValuesChange({ ...value, invoice: Number(invoiceValue) || 0 });
  };

  const updateCommissionValues = nextCommissionValues => {
    notifyValuesChange({
      ...value,
      ...nextCommissionValues
    });
  };

  const salesLocations = appChoices.find(choice => choice.key === 'salesLocation')?.values || [];

  return (
    <>
      <div className="mt-4 w-100">
        <p className="mb-3 text-muted text-left" style={{ fontSize: '0.75rem' }}>
          ──── OR ────
        </p>

        <div className="w-100">
          <label htmlFor="custom-invoice" className="form-label fw-medium mb-1 d-block text-left" style={{ fontSize: '0.85rem' }}>
            Invoice Amount
          </label>
          <div className="input-group input-group-sm" style={{ width: 'fit-content', maxWidth: '100%' }}>
            <TextInput
              id="custom-invoice"
              variant="number"
              size="sm"
              className="form-control border-primary"
              style={{ width: '250px', maxWidth: '250px', flex: '0 0 250px' }}
              onChange={e => updateInvoice(e.target.value)}
              value={value.invoice || 0}
              placeholder="Enter invoice amount..."
            />
            <div className="input-group-append">
              <Button
                variant="outline-primary"
                className="tinyFont"
                style={{ whiteSpace: 'nowrap' }}
                onClick={() => setShowCommissionSidebar(true)}
              >
                Edit Commission Values
              </Button>
            </div>
          </div>
          <p className="text-muted mt-1 mb-0 text-left" style={{ fontSize: '0.75rem' }}>
            Enter an invoice amount if needed
          </p>
        </div>
      </div>

      <CommissionValuesSidebar
        visible={showCommissionSidebar}
        onClose={() => setShowCommissionSidebar(false)}
        value={{
          commissionSheetOptions: value.commissionSheetOptions,
          commissionSheetLessOptions: value.commissionSheetLessOptions
        }}
        onChange={updateCommissionValues}
        appChoices={appChoices}
        unitLocationId={salesLocations[0]?._id}
        numberOfSections={1}
      />
    </>
  );
});

MockCommissionManualFields.displayName = 'MockCommissionManualFields';

export default MockCommissionManualFields;
